var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaremdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 54,
    viewBox: "0 0 232 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-146.9 -223.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Typo",
    "data-name": "Logo Typo",
    transform: "translate(146.9 223.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M177.431,18.254V36.678h-4.463V23.028A59.4,59.4,0,0,1,177.431,18.254Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M191.639,16.092a8.278,8.278,0,0,1,8.368,8.166,8.019,8.019,0,0,1-2.448,5.777,8.42,8.42,0,0,1-5.92,2.394H185.5V17.422q.969-.695,1.957-1.33h4.179m0-4.25h-5.452a51.637,51.637,0,0,0-5.036,3.485V36.678h10.488a12.839,12.839,0,0,0,9-3.639,12.238,12.238,0,0,0,3.723-8.781,12.57,12.57,0,0,0-12.721-12.416Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M152.341,36.678V11.842h4.809l7.666,11.534C175.41,8.668,200.29-8.33,232,4.575c0,0-41.816-16.027-67.323,26.016l-8.015-12.208v18.3Z",
    fill: "#5dcbc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "The_Care",
    "data-name": "The Care"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M0,11.842H17.41v3.324H10.769V36.678H6.677V15.166H0Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M19.744,11.842h4.093v7.434a7.857,7.857,0,0,1,6.138-2.609c4.416,0,7.862,2.894,7.862,8.4V36.678H33.78V25.672c0-3.609-1.974-5.468-4.954-5.468-3.015,0-4.989,1.859-4.989,5.468V36.678H19.744Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M49.756,36.678c-5.672,0-9.872-3.68-9.872-9.862s4.02-10.149,9.872-10.149c5.635,0,9.62,3.9,9.62,9.684a12.474,12.474,0,0,1-.144,2H44.119a5.432,5.432,0,0,0,5.637,5.217,4.791,4.791,0,0,0,4.666-2.751h4.415C57.725,34.248,54.6,36.678,49.756,36.678Zm-5.6-11.614H55.1c-.072-3.037-2.477-4.967-5.528-4.967A5.379,5.379,0,0,0,44.155,25.064Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M80.52,11.521c5.206,0,9.693,2.608,11.6,7.468H87.2A6.975,6.975,0,0,0,80.52,15.1c-4.953,0-8.543,3.5-8.543,9.112s3.59,9.148,8.543,9.148a6.975,6.975,0,0,0,6.677-3.9h4.918c-1.9,4.86-6.389,7.218-11.6,7.218-7.035,0-12.743-5-12.743-12.471A12.451,12.451,0,0,1,80.52,11.521Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M103.065,16.667a8.434,8.434,0,0,1,6.857,3.18V16.988h4.128v19.69h-4.128v-2.93c-1.256,1.68-3.626,2.93-6.929,2.93-5.133,0-9.261-3.859-9.261-9.934S97.86,16.667,103.065,16.667Zm.862,3.537c-3.051,0-6,2.287-6,6.54s2.944,6.718,6,6.718c3.087,0,5.995-2.394,5.995-6.646C109.922,22.6,107.014,20.2,103.927,20.2Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M121.733,36.678h-4.092V16.988h4.092v2.859a6.45,6.45,0,0,1,5.923-3.18v4.216h-1.041c-3.015,0-4.882,1.251-4.882,5.432Z",
    fill: "#0b0c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M138.138,36.678c-5.671,0-9.871-3.68-9.871-9.862s4.02-10.149,9.871-10.149c5.636,0,9.621,3.9,9.621,9.684a12.474,12.474,0,0,1-.144,2H132.5a5.432,5.432,0,0,0,5.636,5.217,4.792,4.792,0,0,0,4.667-2.751h4.415C146.107,34.248,142.984,36.678,138.138,36.678Zm-5.6-11.614h10.949c-.072-3.037-2.477-4.967-5.528-4.967A5.379,5.379,0,0,0,132.538,25.064Z",
    fill: "#0b0c15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tagline",
    transform: "translate(146.9 223.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M15.523,49.435V53.9H14.245V44.113h1.278v4.536l4.044-4.536h1.616l-4.439,4.9L21.225,53.9H19.554Z",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M31.436,45.152H27.447v3.272h3.567v1.053H27.447v3.371h3.989V53.9H26.169V44.1h5.267Z",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M42.151,45.152H38.163v3.272H41.73v1.053H38.163v3.371h3.988V53.9H36.885V44.1h5.266Z",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M50.76,49.814H48.878V53.9H47.6V44.113h3.16c2.3,0,3.385,1.263,3.385,2.865C54.145,48.466,53.19,49.814,50.76,49.814Zm0-1.053c1.461,0,2.079-.688,2.079-1.783,0-1.138-.618-1.812-2.079-1.812H48.878v3.6Z",
    transform: "translate(0.043)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M59.243,44.113h1.278V53.9H59.243Z",
    transform: "translate(0.057)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M73.9,44.1v9.8H72.627l-5.14-7.8v7.8H66.209V44.1h1.278l5.14,7.781V44.1Z",
    transform: "translate(0.068)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M88.54,46.949H87.008a3.122,3.122,0,0,0-2.977-1.8A3.555,3.555,0,0,0,80.422,49a3.55,3.55,0,0,0,3.609,3.834,3.3,3.3,0,0,0,3.441-3.174h-3.9V48.621h5.267V49.6a4.748,4.748,0,0,1-4.8,4.382,4.994,4.994,0,0,1,0-9.986A4.629,4.629,0,0,1,88.54,46.949Z",
    transform: "translate(0.086)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M100.478,44.113H101.9l2.415,4.957,2.416-4.957h1.419l-3.188,6.1V53.9H103.68V50.208Z",
    transform: "translate(0.113)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M117.443,54a5,5,0,1,1,4.916-5A4.829,4.829,0,0,1,117.443,54Zm0-1.109A3.576,3.576,0,0,0,121.053,49a3.62,3.62,0,1,0-7.219,0A3.576,3.576,0,0,0,117.443,52.891Z",
    transform: "translate(0.13)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M127.527,44.113h1.279v6.193c0,1.8.969,2.57,2.415,2.57s2.4-.772,2.4-2.57V44.113H134.9v6.179a3.687,3.687,0,1,1-7.374,0Z",
    transform: "translate(0.148)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M147.049,44.113h1.362l2.135,8.3,2.36-8.3h1.432l2.247,8.272,2.149-8.272h1.376L157.273,53.9h-1.432l-2.276-7.879L151.206,53.9l-1.419.014Z",
    transform: "translate(0.18)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M170.293,45.152H166.3v3.272h3.568v1.053H166.3v3.371h3.989V53.9h-5.267V44.1h5.267Z",
    transform: "translate(0.22)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M177.02,44.113v8.749h3.427V53.9h-4.705V44.113Z",
    transform: "translate(0.22)",
    fill: "#a4afae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M186.6,44.113v8.749h3.427V53.9h-4.7V44.113Z",
    transform: "translate(0.22)",
    fill: "#a4afae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaremdLogo);
export default __webpack_public_path__ + "static/media/caremd-logo.1e4290636229dc484ae45c920e632996.svg";
export { ForwardRef as ReactComponent };